<template>
    <div class="echart" :id="id"></div>
</template>
<script>

export default {
    name:'homeMapChart',
    data(){
         return {
            chart:'',
            geoCoordMap : {
                '北京': [116.46, 39.92],
                '上海': [121.29, 31.14],
                '天津': [117.2, 39.13],
                '重庆': [106.32, 29.32],
                '黑龙江': [126.41, 45.45],
                '吉林': [125.19, 43.52],
                '辽宁': [123.24, 41.50],
                '内蒙古': [111.48, 40.49],
                '河北': [114.28, 38.02],
                '山西': [112.34, 37.52],
                '山东': [117, 36.38],
                '河南': [113.42, 34.48],
                '陕西': [108.54, 34.16],
                '甘肃': [103.49, 36.03],
                '宁夏': [106.16, 38.20],
                '青海': [101.45, 36.38],
                '新疆': [87.36, 43.48],
                '安徽': [117.18, 31.51],
                '江苏': [118.50, 32.02],
                '浙江': [120.09, 30.14],
                '湖南': [113, 28.11],
                '江西': [115.52, 28.41],
                '湖北': [114.21, 30.37],
                '四川': [104.05, 30.39],
                '贵州': [106.42, 26.35],
                '福建': [119.18, 26.05],
                '广东': [113.15, 23.08],
                '海南': [110.20, 20.02],
                '台湾': [121.54, 25.06],
                '广西': [108.20, 22.48],
                '云南': [102.41, 25],
                '西藏': [91.10, 29.40],
                '香港': [114.10, 22.18],
                '澳门': [111.95,21.85]
            }
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        colorArr:{
            type: Array,
            default: function () {
                return ["#16aaff", "#0c1974"]
            }
        },
        optionName:{
            type: String 
        },
        startDate:{
            type: String 
        },
        endDate:{
            type: String 
        },
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        convertData(data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
                var geoCoord = this.geoCoordMap[data[i].name];
                if (geoCoord) {
                    res.push({
                        name: data[i].name,
                        value: geoCoord.concat(data[i].value)
                    });
                }
            }
            return res;
        },
        
        mapOption(name){
            let data = this.dataArray,_this=this;
            let dataTop = data.slice(0,10);
            let maxValue = data[0].value;
            let beliel = maxValue/30;
            let option = {
                tooltip : {
                    trigger: 'item',
                    formatter: function (params) {
                        if(typeof(params.value)[2] == "undefined"){
                            return params.name + ' : ' + params.value;
                        }else{
                            return params.name + ' : ' + params.value[2];
                        }
                    }
                },
                geo: {
                    map: 'china',
                    zoom:1,
                    left: '5%',
                    right: '5%',
                    label: {
                        emphasis: {
                            show: false
                        }
                    },
                    //roam: true,
                    itemStyle: {
                        normal: {
                            areaColor: 'transparent',
                            borderColor: _this.colorArr[0],
                            borderWidth:1,
                            shadowBlur: 10,
                            shadowColor: '#021a63'
                        },
                        emphasis: {
                            areaColor:  _this.colorArr[1]
                        }
                    }
                },
                series : [
                    {
                        name: '信息累计总量',
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: _this.convertData(data),
                        symbolSize: function (val) {
                            let oriSize = val[2] ;
                            let zhi = oriSize/beliel;
                            let tempSize = zhi < 4 ? 4 : zhi;
                            return tempSize;
                        },
                        label: {
                            normal: {
                                formatter: '{b}',
                                position: 'right',
                                show: false
                            },
                            emphasis: {
                                show: true
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#ddb926'
                            }
                        }
                    },
                    {
                        name: 'Top 10',
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        data: _this.convertData(dataTop),
                        symbolSize: function (val) {
                            let oriSize = val[2] ;
                            let tempSize = oriSize/beliel;
                            return tempSize;
                        },
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke'
                        },
                        hoverAnimation: true,
                        label: {
                            normal: {
                                formatter: '{b}',
                                position: 'right',
                                show: true
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#f4e925',
                                shadowBlur: 10,
                                shadowColor: '#333'
                            }
                        },
                        zlevel: 1
                    }
                ]
            };
            return option;
        },
        loadMap(mapCode, name) {
            let _this = this;
            _this.$axios.get(mapCode).then(res=>{
                _this.$echarts.registerMap(name, res.data);
                _this.chart.setOption(_this.mapOption(name));                
            }).catch(error =>{
              //console.log(error);
            });
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
             _this.loadMap('/static/json/china.json', 'china');
             window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
            _this.chart.on('click', function (param) {
                let type = _this.jump;
                if(type != ''){//不为空需要跳转
                    let query = {
                        pubArea:param.name,
                        dayType:4,
                        endDate:_this.endDate,
                        startDate:_this.startDate
                    }
                    console.log(_this.endDate)
                    let routeData = _this.$router.resolve({ path:'/analysis/informationSet',query:query});
                    window.open(routeData.href, '_blank');
                }
                
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/homeMapChart.vue